var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "185px",
    height: "130px",
    viewBox: "0 0 185 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0412 0.3305 46.084 0.3305 46.084 46.3735 0.0412 46.3735"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1---Mobile",
    transform: "translate(-95.000000, -293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(95.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(137.977100, 50.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3442,4.5505 C32.5962,1.8895 28.0192,0.3305 23.0712,0.3305 C22.9702,0.3305 22.8692,0.3305 22.7702,0.3445 C19.6222,0.3735 16.6192,1.0455 13.9022,2.2335 C5.7482,5.7665 0.0412,13.8905 0.0412,23.3455 C0.0412,36.0615 10.3542,46.3735 23.0712,46.3735 C24.2722,46.3735 25.4452,46.2875 26.5892,46.1025 C28.7782,45.7735 30.8652,45.1295 32.7962,44.2145 C38.6902,41.4675 43.2242,36.2895 45.1122,29.9675 C45.7412,27.8645 46.0842,25.6485 46.0842,23.3455 C46.0842,15.5785 42.2372,8.7125 36.3442,4.5505",
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123,78.2223 C123,95.6293 136.789,109.7333 153.781,109.7333",
    id: "Stroke-14",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.912,48.956 C176.912,55.283 171.783,60.412 165.456,60.412 C159.129,60.412 154,55.283 154,48.956 C154,42.629 159.129,37.5 165.456,37.5 C171.783,37.5 176.912,42.629 176.912,48.956 Z",
    id: "Stroke-30",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.551,50.5058 C78.517,58.2508 85.676,71.0268 85.676,85.4798 C85.676,89.7648 85.037,93.8898 83.866,97.8028 C80.353,109.5668 71.916,119.2018 60.95,124.3118 C57.357,126.0158 53.471,127.2128 49.399,127.8248 C47.27,128.1708 45.087,128.3308 42.851,128.3308 C19.19,128.3308 -2.62900812e-13,109.1408 -2.62900812e-13,85.4798 C-2.62900812e-13,67.8868 10.619,52.7688 25.79,46.1938 C30.848,43.9848 36.437,42.7348 42.292,42.6818 C42.479,42.6538 42.665,42.6538 42.851,42.6538 C52.061,42.6538 60.577,45.5558 67.551,50.5058",
    id: "Fill-55",
    fill: "#FFF6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7502,42.6542 C9.7502,44.5982 8.1752,46.1742 6.2302,46.1742 C4.2872,46.1742 2.7112,44.5982 2.7112,42.6542 C2.7112,40.7112 4.2872,39.1342 6.2302,39.1342 C8.1752,39.1342 9.7502,40.7112 9.7502,42.6542",
    id: "Fill-56",
    fill: "#F7A800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(55.793800, 54.520400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.642,0.25 C10.642,3.105 8.319,5.429 5.463,5.429 C2.608,5.429 0.285,3.105 0.285,0.25",
    id: "Fill-57",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.642,0.25 C10.642,3.105 8.319,5.429 5.463,5.429 C2.608,5.429 0.285,3.105 0.285,0.25",
    id: "Stroke-58",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.4944,51.0878 L77.4944,54.7708 L45.0194,54.7708 L45.0194,51.0878 C45.0194,49.7758 46.0844,48.2358 47.3964,48.2358 L47.9564,48.0398 L47.9564,37.4068 C47.9564,31.0088 52.2764,25.7108 58.3024,24.4398 C58.2884,24.3428 58.3234,24.1728 58.3234,24.0758 C58.3234,22.5348 59.7164,21.3148 61.2574,21.3148 C62.3554,21.3148 63.4154,21.9338 63.8714,22.8528 C64.0574,23.2258 64.2214,23.6268 64.2214,24.0758 C64.2214,24.1728 64.2574,24.3498 64.2434,24.4458 C65.4734,24.7018 66.4044,25.0798 67.4824,25.6608 C67.6134,25.7228 67.7454,25.7918 67.8694,25.8748 C71.8634,28.1618 74.5574,32.4668 74.5574,37.4068 L74.5574,47.7108 L75.1174,48.2578 C76.4304,48.2578 77.4944,49.7758 77.4944,51.0878",
    id: "Fill-60",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4944,51.0878 L77.4944,54.7708 L45.0194,54.7708 L45.0194,51.0878 C45.0194,49.7758 46.0844,48.2358 47.3964,48.2358 L47.9564,48.0398 L47.9564,37.4068 C47.9564,31.0088 52.2764,25.7108 58.3024,24.4398 C58.2884,24.3428 58.3234,24.1728 58.3234,24.0758 C58.3234,22.5348 59.7164,21.3148 61.2574,21.3148 C62.3554,21.3148 63.4154,21.9338 63.8714,22.8528 C64.0574,23.2258 64.2214,23.6268 64.2214,24.0758 C64.2214,24.1728 64.2574,24.3498 64.2434,24.4458 C65.4734,24.7018 66.4044,25.0798 67.4824,25.6608 C67.6134,25.7228 67.7454,25.7918 67.8694,25.8748 C71.8634,28.1618 74.5574,32.4668 74.5574,37.4068 L74.5574,47.7108 L75.1174,48.2578 C76.4304,48.2578 77.4944,49.7758 77.4944,51.0878 Z",
    id: "Stroke-61",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.425,52.037 C95.507,68.968 79.881,81.342 61.364,81.342 C38.903,81.342 20.694,63.133 20.694,40.671 C20.694,18.209 38.903,2.84217094e-13 61.364,2.84217094e-13 C69.31,2.84217094e-13 76.723,2.278 82.987,6.218",
    id: "Stroke-62",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBell);
export default __webpack_public_path__ + "static/media/mobileBell.04e66cd51fda0b083f3611beb4cd4905.svg";
export { ForwardRef as ReactComponent };